(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/react/deposit-limits-faq.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/react/deposit-limits-faq.js');
'use strict';

const WidgetArea = svs.components.tb_ui_react.widget_area.WidgetArea;
const Button = svs.ui.ReactButton;
const DepositLimitsFAQ = () => {
  const onCustomerServiceClick = () => {
    svs.utils.url.navigate(svs.core.urlMapping.get('customerServiceContact'));
  };
  return React.createElement(WidgetArea, {
    areaName: "depositFAQ",
    className: "deposit-limits-faq",
    fallback: React.createElement("div", {
      className: "u-text-center my-limits-faq"
    }, React.createElement("div", {
      className: "u-border-radius-6 bg-tur-100 padding-h-1 padding-v-2"
    }, React.createElement("h2", {
      className: "h4 margin-bottom-2"
    }, "Just nu kan vi inte ladda fr\xE5gor och svar"), React.createElement("div", {
      className: "margin-bottom-2"
    }, React.createElement("p", null, "G\xE5 till kundservice om du har fr\xE5gor")), React.createElement("div", null, React.createElement(Button, {
      onClick: onCustomerServiceClick,
      transparent: true,
      type: "button"
    }, "Till kundservice"))))
  });
};
svs.accountservicesReact.gameLimitDepositsForm.DepositLimitsFAQ = DepositLimitsFAQ;

 })(window);